(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(52241);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx + 29 modules
var Box = __webpack_require__(7180);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/StyledCard.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 3s ease infinite;\n      background-size: 400% 400%;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  overflow: hidden;\n  position: relative;\n\n  ",
        "\n\n  padding: 1px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  overflow: ",
        ";\n  background: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var PromotedGradient = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
/**
 * Priority: Warning --> Success --> Active
 */ var getBorderColor = function getBorderColor(param) {
    var isActive = param.isActive, isSuccess = param.isSuccess, isWarning = param.isWarning, borderBackground = param.borderBackground, theme = param.theme;
    if (borderBackground) {
        return borderBackground;
    }
    if (isWarning) {
        return theme.colors.warning;
    }
    if (isSuccess) {
        return theme.colors.success;
    }
    if (isActive) {
        return "linear-gradient(180deg, ".concat(theme.colors.primaryBright, ", ").concat(theme.colors.secondary, ")");
    }
    return theme.colors.cardBorder;
};
var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eb0c6e5d-0"
}).withConfig({
    componentId: "sc-82cb7c1e-0"
})(_templateObject2(), getBorderColor, function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var theme = param.theme, isDisabled = param.isDisabled;
    return theme.colors[isDisabled ? "textDisabled" : "text"];
}, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), PromotedGradient);
}, index_esm/* space */.Dh);
var StyledCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-eb0c6e5d-1"
}).withConfig({
    componentId: "sc-82cb7c1e-1"
})(_templateObject3(), function(param) {
    var hasCustomBorder = param.hasCustomBorder;
    return hasCustomBorder ? "initial" : "inherit";
}, function(param) {
    var theme = param.theme, background = param.background;
    return background !== null && background !== void 0 ? background : theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
StyledCard.defaultProps = {
    isActive: false,
    isSuccess: false,
    isWarning: false,
    isDisabled: false
};

;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/Card.tsx






var Card = function Card(_param) {
    var ribbon = _param.ribbon, children = _param.children, background = _param.background, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ribbon",
        "children",
        "background"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardInner, {
            background: background,
            hasCustomBorder: !!props.borderBackground,
            children: [
                ribbon,
                children
            ]
        })
    }));
};
/* harmony default export */ var Card_Card = (Card);


/***/ }),

/***/ 52241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx + 29 modules
var Box = __webpack_require__(7180);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(38144);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(84091);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/state/capital/hooks.ts + 1 modules
var hooks = __webpack_require__(92458);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(35128);
// EXTERNAL MODULE: ./src/views/Swap/styles.tsx
var styles = __webpack_require__(76900);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 2 modules
var Page = __webpack_require__(89491);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/views/Capital/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 6px;\n  width: 100%;\n  flex-direction: column;\n  ",
        " {\n    flex-direction: row;\n    padding: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-self: baseline;\n  position: relative;\n  background: ",
        ";\n  border-radius: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 6px;\n  border-radius: 8px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 328px;\n  text-align: -webkit-center;\n  ",
        " {\n    width: 436px;\n  }\n  ",
        " {\n    width: 800px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 12px;\n  max-width: 800px;\n  width: 100%;\n  z-index: 1;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}











var StepContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5a638740-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xl;
});
var StyledStepCard = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-5a638740-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gradients;
});
var StepCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-5a638740-2"
})(_templateObject2());
var StyledInputCurrencyWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-5a638740-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var BodyWrapper = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-5a638740-4"
})(_templateObject4());
function AppBody(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyWrapper, {
        children: children
    });
}
var StepCard = function(param) {
    var step = param.step;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStepCard, {
        width: "100%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepCardInner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    mb: "16px",
                    fontSize: "14px",
                    bold: true,
                    textAlign: "center",
                    children: step.label
                }),
                step.title === "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: 100,
                    height: 27,
                    mb: 16
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    scale: "md",
                    color: "secondary",
                    children: step.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "textSubtle",
                    children: step.subtitle
                })
            ]
        })
    });
};
var Capital = function() {
    var ref = (0,hooks/* useCapital */.k$)(), bonds = ref.bonds, vault = ref.vault;
    var ref1 = (0,react.useState)("0"), taiPrice = ref1[0], setTaiPrice = ref1[1];
    (0,hooks/* usePollBondsData */.vi)();
    (0,hooks/* usePollBondsWithUserData */.PB)();
    (0,react.useEffect)(function() {
        fetch("https://api.dexscreener.com/latest/dex/pairs/solana/99a2qtflaxv9lvhkesjeawjky8pwb4cypc5ccucb4vus").then(function(res) {
            if (res.ok) {
                res.json().then(function(json) {
                    setTaiPrice(json.pairs[0].priceUsd);
                });
            }
        });
    }, []);
    var treasuryBalances = bonds ? bonds.map(function(bond) {
        return bond.purchased;
    }) : [];
    var totalPurchased = treasuryBalances.reduce(function(value0, value1, index) {
        return new (bignumber_default())(value0).plus(new (bignumber_default())(value1).div(bigNumber/* BIG_TEN.pow */.xp.pow(bonds[index].bondToken.decimals)));
    }, bigNumber/* BIG_ZERO */.HW);
    var t = (0,Localization/* useTranslation */.$G)().t;
    var tasTge = Number(taiPrice) * 69230;
    totalPurchased = totalPurchased.plus(new (bignumber_default())(12500)).plus(new (bignumber_default())(8333)).plus(new (bignumber_default())(tasTge));
    var steps1 = [
        {
            label: t("VNTR Price"),
            title: vault ? "$".concat(vault.marketPrice ? (0,formatBalance/* getBalanceNumber */.mW)(new (bignumber_default())(vault.marketPrice), 0).toLocaleString() : "-") : "",
            subtitle: t("")
        },
        {
            label: t("MarketCap"),
            title: vault ? "$".concat(vault.marketCap ? (0,formatBalance/* getFullDisplayBalance */.NJ)(new (bignumber_default())(vault.marketCap), 0, 0).toLocaleString() : "-") : "",
            subtitle: t("")
        },
        {
            label: t("Circulating Supply(Total)"),
            title: vault ? "".concat(vault.circSupply ? (0,formatBalance/* getFullDisplayBalance */.NJ)(new (bignumber_default())(vault === null || vault === void 0 ? void 0 : vault.circSupply), 9, 0) : "-", "/").concat(vault.totalSupply ? (0,formatBalance/* getFullDisplayBalance */.NJ)(new (bignumber_default())(vault === null || vault === void 0 ? void 0 : vault.totalSupply), 9, 0) : "-") : "",
            subtitle: t("")
        }, 
    ];
    var steps2 = [
        {
            label: t("Backing per VNTR"),
            title: "$".concat(!totalPurchased.isNaN() && (vault === null || vault === void 0 ? void 0 : vault.circSupply) ? (0,formatBalance/* getFullDisplayBalance */.NJ)(new (bignumber_default())(totalPurchased).times(bigNumber/* BIG_TEN.pow */.xp.pow(9)).div(new (bignumber_default())(vault === null || vault === void 0 ? void 0 : vault.circSupply)), 0, 3) : "-"),
            subtitle: t("")
        },
        {
            label: t("Current Index"),
            title: vault ? "".concat(vault.currentIndex ? (0,formatBalance/* getFullDisplayBalance */.NJ)(new (bignumber_default())(vault.currentIndex), 9, 2) : "-", " VNTR") : "",
            subtitle: t("")
        },
        {
            label: t("Treasury Balance"),
            title: "$".concat(!totalPurchased.isNaN() ? (0,formatBalance/* getFullDisplayBalance */.NJ)(new (bignumber_default())(totalPurchased), 0, 0) : "-"),
            subtitle: t("")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "center",
                position: "relative",
                mb: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledSwapContainer */.g, {
                    $isChartExpanded: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInputCurrencyWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBody, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                width: "100%",
                                p: 24,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        justifyContent: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StepContainer, {
                                            children: steps1.map(function(step) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepCard, {
                                                    step: step
                                                }, step.label);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        justifyContent: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StepContainer, {
                                            children: steps2.map(function(step) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepCard, {
                                                    step: step
                                                }, step.label);
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "center",
                position: "relative",
                mb: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledSwapContainer */.g, {
                    $isChartExpanded: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInputCurrencyWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBody, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                width: "100%",
                                p: 24,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mb: "16px",
                                        fontSize: "20px",
                                        bold: true,
                                        textAlign: "center",
                                        children: "Crypto Holdings"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        justifyContent: "center",
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                justifyContent: "space-between",
                                                mb: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "30%",
                                                        children: "Token"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "30%",
                                                        children: "QTY"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "30%",
                                                        children: "USD Value"
                                                    })
                                                ]
                                            }),
                                            bonds.map(function(bond) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    justifyContent: "space-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            width: "30%",
                                                            color: "primary",
                                                            children: bond.bondToken.symbol
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            width: "30%",
                                                            color: "primary",
                                                            children: (bond === null || bond === void 0 ? void 0 : bond.treasuryBalance) ? "".concat((0,formatBalance/* getFullDisplayBalance */.NJ)(new (bignumber_default())(bond === null || bond === void 0 ? void 0 : bond.treasuryBalance), bond.bondToken.decimals, 4)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                width: 100,
                                                                height: 24,
                                                                mb: 1
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            width: "30%",
                                                            color: "primary",
                                                            children: (bond === null || bond === void 0 ? void 0 : bond.purchased) ? "$".concat((0,formatBalance/* getFullDisplayBalance */.NJ)(new (bignumber_default())(bond.purchased), bond.bondToken.decimals, 0)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                width: 100,
                                                                height: 24,
                                                                mb: 1
                                                            })
                                                        })
                                                    ]
                                                });
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "center",
                position: "relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledSwapContainer */.g, {
                    $isChartExpanded: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInputCurrencyWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBody, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                width: "100%",
                                p: 24,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mb: "16px",
                                        fontSize: "20px",
                                        bold: true,
                                        textAlign: "center",
                                        children: "Early Stage Investment"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        justifyContent: "center",
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                justifyContent: "space-between",
                                                mb: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "33%",
                                                        style: {
                                                            overflowWrap: "anywhere"
                                                        },
                                                        children: "Project/Company"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "33%",
                                                        style: {
                                                            overflowWrap: "anywhere"
                                                        },
                                                        children: "Asset QTY"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "33%",
                                                        style: {
                                                            overflowWrap: "anywhere"
                                                        },
                                                        children: "TGE Value"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                justifyContent: "space-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "33%",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            as: "a",
                                                            href: "https://tars.pro/",
                                                            target: "_blank",
                                                            scale: "sm",
                                                            variant: "text",
                                                            children: "TARS(TAI)"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "33%",
                                                        color: "primary",
                                                        children: "69,230"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        width: "33%",
                                                        color: "primary",
                                                        children: [
                                                            "$",
                                                            tasTge.toLocaleString()
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                justifyContent: "space-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "33%",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            as: "a",
                                                            href: "https://solvent.app/",
                                                            target: "_blank",
                                                            scale: "sm",
                                                            variant: "text",
                                                            children: "SOLVENT"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "33%",
                                                        color: "primary",
                                                        children: "50,000"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "33%",
                                                        color: "primary",
                                                        children: "$12,500"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                justifyContent: "space-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "33%",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            as: "a",
                                                            href: "https://projectvea.com/",
                                                            target: "_blank",
                                                            scale: "sm",
                                                            variant: "text",
                                                            children: "VEA"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "33%",
                                                        color: "primary",
                                                        children: "16,666"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "33%",
                                                        color: "primary",
                                                        children: "$8,333"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var views_Capital = (Capital);

;// CONCATENATED MODULE: ./src/pages/index.tsx


var DashboardPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(views_Capital, {});
};
/* harmony default export */ var pages = (DashboardPage);


/***/ }),

/***/ 92458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k$": function() { return /* binding */ useCapital; },
  "vi": function() { return /* binding */ usePollBondsData; },
  "PB": function() { return /* binding */ usePollBondsWithUserData; },
  "d0": function() { return /* binding */ useVNTRUSDTPrice; }
});

// UNUSED EXPORTS: useBondFromId, useBondFromName, useBondUser

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(3862);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/index.ts + 47 modules
var state = __webpack_require__(79868);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.mjs
var dist = __webpack_require__(49770);
// EXTERNAL MODULE: ./src/config/constants/bonds.ts
var bonds = __webpack_require__(18564);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(35128);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(90834);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 32 modules
var src = __webpack_require__(54346);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
;// CONCATENATED MODULE: ./src/state/capital/selectors.ts
/* eslint-disable @typescript-eslint/no-unused-vars */ 
var selectBondByKey = function(key, value) {
    return function(state) {
        return state.capital.bonds.find(function(b) {
            return b[key] === value;
        });
    };
};
var selectors_makeBondFromIdSelector = function(id) {
    return createSelector([
        selectBondByKey("id", id)
    ], function(bond) {
        return bond;
    });
};
var selectors_bondFromNameSelector = function(name) {
    return createSelector([
        selectBondByKey("name", name)
    ], function(bond) {
        return bond;
    });
};
var selectors_makeUserBondFromIdSelector = function(id) {
    return createSelector([
        selectBondByKey("id", id)
    ], function(bond) {
        return bond.userData;
    });
};
var capitalSelector = function(chainId) {
    return (0,reselect_es/* createSelector */.P1)(function(state) {
        return state.capital;
    }, function(capital) {
        var bonds = capital.bonds;
        var vault = capital.vault, userDataLoaded = capital.userDataLoaded;
        return {
            bonds: bonds,
            vault: vault,
            userDataLoaded: userDataLoaded
        };
    });
};

// EXTERNAL MODULE: ./src/state/capital/index.ts + 7 modules
var capital = __webpack_require__(93920);
;// CONCATENATED MODULE: ./src/state/capital/hooks.ts
















var usePollBondsData = function() {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var chainId = (0,core_esm/* useWeb3React */.Ge)().chainId;
    (0,dist/* default */.Z)(chainId ? [
        "publicBondData",
        chainId
    ] : [
        "publicBondData",
        src/* ChainId.BSC */.a_.BSC
    ], (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ids;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ids = bonds/* default.map */.Z.map(function(bondToFetch) {
                        return bondToFetch.id;
                    });
                    dispatch((0,capital/* fetchCapitalPublicDataAsync */.pM)({
                        ids: ids,
                        chainId: chainId !== null && chainId !== void 0 ? chainId : src/* ChainId.BSC */.a_.BSC
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        refreshInterval: constants/* SLOW_INTERVAL */.KI
    });
};
var usePollBondsWithUserData = function() {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var name = [
        "bondsWithUserData",
        account,
        chainId
    ];
    (0,dist/* default */.Z)(account && chainId ? name : null, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ids, params;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ids = bonds/* default.map */.Z.map(function(bondToFetch) {
                        return bondToFetch.id;
                    });
                    params = {
                        account: account,
                        ids: ids,
                        chainId: chainId
                    };
                    dispatch((0,capital/* fetchCapitalUserDataAsync */.qe)(params));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        refreshInterval: constants/* SLOW_INTERVAL */.KI
    });
};
var useCapital = function() {
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    return (0,es/* useSelector */.v9)((0,react.useMemo)(function() {
        return capitalSelector(chainId);
    }, [
        chainId
    ]));
};
var useBondFromId = function(id) {
    var bondFromPid = useMemo(function() {
        return makeBondFromIdSelector(id);
    }, [
        id
    ]);
    return useSelector(bondFromPid);
};
var useBondFromName = function(name) {
    var bondFromName = useMemo(function() {
        return bondFromNameSelector(name);
    }, [
        name
    ]);
    return useSelector(bondFromName);
};
var useBondUser = function(id) {
    var bondFromIdUser = useMemo(function() {
        return makeUserBondFromIdSelector(id);
    }, [
        id
    ]);
    return useSelector(bondFromIdUser);
};
var useVNTRUSDTPrice = function() {
    var price = (0,useBUSDPrice/* useCakeBusdPrice */.S9)();
    return (0,react.useMemo)(function() {
        return price ? new (bignumber_default())(price.toSignificant(6)) : bigNumber/* BIG_ZERO */.HW;
    }, [
        price
    ]);
};


/***/ }),

/***/ 76900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ StyledInputCurrencyWrapper; },
/* harmony export */   "g": function() { return /* binding */ StyledSwapContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7180);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-shrink: 0;\n  height: fit-content;\n  padding: 0 24px;\n\n  ",
        " {\n    padding: 0 40px;\n  }\n\n  ",
        " {\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 328px;\n  text-align: -webkit-center;\n  ",
        " {\n    width: 436px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledSwapContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-2f539eb0-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xxl;
}, function(param) {
    var $isChartExpanded = param.$isChartExpanded;
    return $isChartExpanded ? "padding: 0 120px" : "padding: 0 40px";
});
var StyledInputCurrencyWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-2f539eb0-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);